/**
 * Rotates visitor counter text within a configured min–max range.
 */
(() => {
  const roots = document.querySelectorAll('.visitor-counter[data-template]');

  roots.forEach((node) => {
    if (!(node instanceof HTMLElement)) return;

    const textNode = node.querySelector('.visitor-counter__text');
    if (!(textNode instanceof HTMLElement)) return;

    const min = Number(node.dataset.min || 20);
    const maxRaw = Number(node.dataset.max || 30);
    const max = maxRaw < min ? min : maxRaw;
    const template =
      node.dataset.template || '{number} people are viewing this right now';
    const intervalSeconds = Math.max(
      1,
      Number(node.dataset.intervalSeconds || 10)
    );

    const update = () => {
      const next = Math.floor(Math.random() * (max - min + 1)) + min;
      textNode.textContent = template.replace('{number}', String(next));
    };

    update();
    window.setInterval(update, intervalSeconds * 1000);
  });
})();
